import { Box, Button, Grid, makeStyles, Paper } from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import HttpClient from "libs/utils/HttpClient";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  wrapContent: {
    marginTop: 30,
  },
  sigPad: { width: "100%", height: "100%" },
  buttons: { width: "100%", height: "30px" },
  wrapSig: {
    padding: "10px",
    border: "1px solid lightgray",
    borderRadius: "10px",
    textAlign: "center",
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "80%",
    height: "80%",
    backgroundColor: "white",
    borderRadius: 15,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },

  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  wrapContoller: {
    display: "flex",
  },
  formControl: {
    width: "100%",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
  },
}));

function EmailDetailPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(async () => {});

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Email Log" />
      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="Email Detail" />

        <div className={classes.wrapContoller}>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            type="submit"
            onClick={async () => {
              const data = {
                logEmailID: location?.state?.data?.logEmailID,
              };
              try {
                const response = await HttpClient.post(
                  "/api/mail/resend",
                  data
                );
                console.log(response);
                if (response.status) {
                  alert(response.message);
                } else {
                  alert(response.message);
                }
                if (response.status) return response;
                return Promise.reject(response);
              } catch (error) {
                const newError = error;
                throw newError;
              }
            }}
            className={classes.buttonDialogSave}
          >
            Resend
          </Button>
        </div>
      </div>

      <div className={classes.wrapContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            {
              <div
                dangerouslySetInnerHTML={{
                  __html: location?.state?.data?.body,
                }}
              />
            }
          </Grid>

          <Box width="100%" />
          <Grid item xs={12} md={4}></Grid>
        </Grid>
      </div>
    </Paper>
  );
}

export default EmailDetailPage;
